import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "nav"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Scrolldex")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sign up")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "download", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Install on homescreen", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_settings = _resolveComponent("settings")!
  const _component_toaster = _resolveComponent("toaster")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isUserLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _hoisted_3,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/login"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "button is-link",
            to: "/sign-up"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_settings)
        ])),
    _createVNode(_component_toaster),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.modalVisibilityState)
          ? (_openBlock(), _createBlock(_component_modal, {
              key: 0,
              title: 'Install app',
              message: 'Would you like your card on your startscreen?',
              callToActionText: 'Install',
              onCallToActionClick: _ctx.install,
              secondaryButtonText: 'Close',
              onSecondaryButtonClick: _ctx.dismiss,
              onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setModalVisiblityTo(false)))
            }, null, 8, ["onCallToActionClick", "onSecondaryButtonClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showInstallPromotion && _ctx.isUserLoggedIn)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "button is-link download-pwa-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.install && _ctx.install(...args)))
        }, _hoisted_9))
      : _createCommentVNode("", true)
  ], 64))
}